import {
  searchPersonResults,
  PersonTeaser,
  type Record,
} from '@ltvco/refresh-lib/v1';

import { constants } from 'appConstants';
import { SEARCH_TYPES } from 'components/ChatBV/constants';
import {
  PersonTeaserFunctionArguments,
  TeaserResult,
} from 'components/ChatBV/types';

export const getPublicRecordsTeaser = async ({
  first_name,
  last_name,
  middle_name,
  age,
  state,
  city,
}: PersonTeaserFunctionArguments): Promise<TeaserResult> => {
  const data = await searchPersonResults(
    {
      searchPersonBy: 'name',
      options: {
        personSearchParams: {
          fName: first_name || '',
          lName: last_name || '',
          age: age?.toString() || '',
          mName: middle_name || '',
          city: city || '',
          state: state || '',
        },
        isOptout: false,
      },
    },
    constants.links.brandLink
  );
  const teaser = new PersonTeaser(data);
  return {
    teaserData:
      teaser.data.slice(0, 5)?.map((item: Record) => ({
        name: item.name || '',
        age: item.age || '',
        currentLocation: item.currentLocation || '',
        bvid: item.bvid || '',
        type: SEARCH_TYPES.PERSON,
      })) || [],
    amountOfResults: teaser.data.length || 0,
  };
};
